export const getImage = path => {
  const images = require.context('../assets/', false);
  return images(path);
};

export const getImagePlaceholder = () => {
  return getImage('./image-placeholder.jpg');
};
